<template>
	<el-dialog title="输入信息" center :visible="show" @close="close" :close-on-click-modal="false">
		<div class="dialog">
			<span class="type_size_18">{{ name }}</span>
			<div class="header_center p_m_t_30 p_flex p_f_a ">
				<span class="p_m_l_20 type_size_18">选择班级</span>
				<div class="p_f_1 p_m_l_20 p_m_r_20">
					<el-select class="p_f_1" v-model="questionTypes" placeholder="请选择选择班级">
						<el-option v-for="item in questionLists" :key="item.id" :label="item.name"
								   :value="item.id"></el-option>
					</el-select>
				</div>
			</div>
			<div class="header_center p_m_t_30 p_flex p_f_a ">
				<span class="p_m_l_20 type_size_18">作业提交时间</span>
				<div class="p_f_1 p_m_l_20 p_m_r_20">
					<el-date-picker class="p_f_1" v-model="time" type="datetime" placeholder="选择日期时间" align="right"
									:picker-options="pickerOptions"></el-date-picker>
				</div>
			</div>
			<div class="header_center p_m_t_30 p_flex p_f_a ">
				<span class="p_m_l_20 type_size_18">选择线上线下</span>
				<el-select v-model="onlineName" placeholder="请选择线上线下" class="p_f_1 p_m_l_20 p_m_r_20">
					<el-option
						v-for="item in onlineList"
						:key="item.id"
						:label="item.name"
						:value="item.name">
					</el-option>
				</el-select>
			</div>
			<div class="p_flex p_f_c">
				<el-button class="p_m_t_30" type="success" @click='goButton'>确认</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
export default {
	props: {
		show: null,
		op: Object
	},
	data() {
		return {
			pickerOptions: {
				shortcuts: [{
					text: '今天',
					onClick(picker) {
						picker.$emit('pick', new Date());
					}
				}, {
					text: '昨天',
					onClick(picker) {
						const date = new Date();
						date.setTime(date.getTime() - 3600 * 1000 * 24);
						picker.$emit('pick', date);
					}
				}, {
					text: '一周前',
					onClick(picker) {
						const date = new Date();
						date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', date);
					}
				}]
			},
			onlineList: [{
				id: 1,
				name: '线上'
			}, {
				id: 2,
				name: '线下'
			}],//线上线下选择列表
			questionTypes: 1,
			time: '',
			questionLists: [],
			onlineName: '',
			name: "",
			id: ""
		};
	},
	watch: {
		op: {
			handler(i, o) {
				// console.log(i)
				this.name = i.name    //名称
				this.id = i.id  //习题册ID
			}
		}
	},
	created() {
		this.teachid = JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).id : ''
		this.$request.ajax(this).post("/api_teacher/job_publish_class_level_list").then(res => {
			// console.log(res)
			this.questionLists = res.data
		})
	},
	methods: {
		close() {
			this.$emit('closes', false);
		},
		goButton() {
			// console.log(this.questionTypes) // 班级id
			// console.log(this.moment(this.time).format("YYYY-MM-DD HH:mm:ss"))    //提交时间
			if (this.onlineName == '线上') {
				this.$request.ajax(this).post("/api_teacher/job_publish_exercise_book", {
					obj_id: this.id,   //习题册id
					class_level_id: this.questionTypes,
					submit_time: this.moment(this.time).format("YYYY-MM-DD HH:mm:ss"), //提交时间
					name: this.name
				}).then(res => {
					// console.log(res)
					this.$message({
						message: "下发成功！",
						type: 'success'
					});
					this.$emit('goButton', false);
				})
			}
			if (this.onlineName == '线下') {
				this.$request.ajax(this).post("/api_teacher/job_publish_exercise_book", {
					obj_id: this.id,   //习题册id
					class_level_id: this.questionTypes,
					submit_time: this.moment(this.time).format("YYYY-MM-DD HH:mm:ss"), //提交时间
					name: this.name
				}).then(res => {
						if (res.msg == "success") {
							let data2 = {}
							data2.teachid = this.teachid
							data2.studentid = ''
							data2.jobpublishid = res.data.id
							data2.type = 1
							data2.img_path = ''
							data2.create_time = null
							data2.status = 0
							this.$request.ajax(this).post('/api_teacher/readytodo_create', data2).then((res2) => {
								if (res2.msg == "success") {
									this.$message({
										type: 'success',
										message: res2.data.msg
									});
									this.$emit('goButton', false);
								} else {
									this.$message({
										message: "下发失败！",
										type: 'error'
									});
									this.$emit('goButton', false);
								}
							})
						} else {
							this.$message({
								message: "下发失败！",
								type: 'error'
							});
							this.$emit('goButton', false);
						}
					}
				)

			}
		}
	}
};
</script>
<style lang="scss" scoped>
.dialog {
	padding: 0;
}

.header_center {
	height: 65px;
	background: #f5f5f5;
	border-radius: 10px;
}

> > > .el-input__inner {
	border: none;
	background: #f5f5f5;
	font-size: 18px;
}

> > > .el-select {
	width: 100%;
}

> > > input::-webkit-input-placeholder {
	font-size: 18px;
}

> > > .el-select .el-input .el-select__caret {
	font-size: 18px;
	color: #000000;
}

> > > .el-date-editor.el-input,
> > > .el-date-editor.el-input__inner {
	width: 100%;
}

> > > .el-date-table td.today span {
	color: #00AF63 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/commponents/mineIssue.vue